module.exports = __webpack_public_path__ + "img/199.eef688cf.jpg";